var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useEffect } from 'react';
import { narrowToWideCompositions } from '../compositions';
import { sanatizeInteger } from '../helpers/util';
import { useWidestComposition } from './useWidestComposition';
export function usePaginationItems(inputCurrent, inputTotal, maxWidth, options) {
    var total = sanatizeInteger(inputTotal);
    var current = total < 1 ? null : Math.max(1, Math.min(sanatizeInteger(inputCurrent), total));
    var narrowToWideCompositionsProvider = function () {
        return narrowToWideCompositions(current, total);
    };
    var _a = useWidestComposition(narrowToWideCompositionsProvider, maxWidth), items = _a.items, ref = _a.ref, clearCache = _a.clearCache;
    useEffect(function () {
        return function () { return clearCache(); };
    }, [clearCache, options === null || options === void 0 ? void 0 : options.previousLabel, options === null || options === void 0 ? void 0 : options.nextLabel]);
    var amendedItems = items.map(function (item) {
        if (item.type === 'next' && (options === null || options === void 0 ? void 0 : options.nextLabel)) {
            return __assign(__assign({}, item), { label: options === null || options === void 0 ? void 0 : options.nextLabel });
        }
        else if (item.type === 'previous' && (options === null || options === void 0 ? void 0 : options.previousLabel)) {
            return __assign(__assign({}, item), { label: options === null || options === void 0 ? void 0 : options.previousLabel });
        }
        else {
            return item;
        }
    });
    return { items: amendedItems, ref: ref, clearCache: clearCache };
}
